/**
 * True when the physical browser viewport matches the handheld profile used by the game
 * (touch + small/narrow screen). Must stay aligned with the non-`?simulate=` branch inside
 * `useContainerScale` (useViewportScale.js) so layout mode and access gating agree.
 */
export function isPhysicalMobileGameViewport() {
  if (typeof window === 'undefined') return false;
  const realW = window.innerWidth;
  const realH = window.innerHeight;
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!hasTouch) return false;
  const shortSide = Math.min(realW, realH);
  // Landscape phone bars + portrait phones/tablets (short side typical handheld range)
  return realH <= 500 || (realW <= 500 && realH <= 932) || shortSide <= 820;
}
